import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Footer from "./view/footer";
import { BrowserRouter, useLocation } from "react-router-dom";
import Header from "./view/header";
import { Layout } from "./styles/commonStyle";
import { QueryClient, QueryClientProvider } from "react-query";
import { RecoilRoot } from "recoil";
import ScrollToTop from "./scrollToTop";

const BARE_PATHS = ["/privacy/embed", "/policy/embed"];
// 고객사(테넌트) QR결제 페이지는 사이트 공통 헤더 대신 자체 헤더(ev CLOUD)를 렌더링한다.
const CUSTOM_HEADER_PATTERNS = [
  /^\/QRtenant\/[^/]+$/,
  /^\/QRtenant\/[^/]+\/[^/]+$/,
  /^\/QRtenant\/[^/]+\/[^/]+\/payment_result$/,
];

function AppShell() {
  const { pathname } = useLocation();
  const isBare = BARE_PATHS.includes(pathname);
  const hasCustomHeader = CUSTOM_HEADER_PATTERNS.some((pattern) => pattern.test(pathname));
  const hideDefaultHeader = isBare || hasCustomHeader;

  return (
    <>
      <ScrollToTop />
      {!hideDefaultHeader && <Header />}
      {hideDefaultHeader ? <App /> : <Layout><App /></Layout>}
      {!isBare && <Footer />}
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
const queryClient = new QueryClient();

root.render(
  <BrowserRouter>
    <RecoilRoot>
      <QueryClientProvider client={queryClient}>
        <AppShell />
      </QueryClientProvider>
    </RecoilRoot>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
